import { useGeographicField } from './GeographicConflict';
import type { SelectHTMLAttributes } from 'react';
import { COUNTRIES } from '../common/data';
import { REGION_OPTIONS } from '../common/adminAccess';

type Props = Omit<SelectHTMLAttributes<HTMLSelectElement>, 'value'> & { value: string; placeholder?: string; allowedCountries?: string[] };

export default function CountrySelect({ value, placeholder = 'Select country', allowedCountries, children, ...props }: Props) {
    const warning = useGeographicField(props.name, true);
    return <select value={value || ''} {...props} {...warning}>
        <option value="">{placeholder}</option>
        {value && !allowedCountries && !COUNTRIES.includes(value) && !REGION_OPTIONS.includes(value as typeof REGION_OPTIONS[number]) && <option value={value}>{value}</option>}
        {children}
        {(allowedCountries || COUNTRIES).map(country => <option key={country} value={country}>{country}</option>)}
    </select>;
}
